module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('detail-page-layout', {
    attrs: {
      "config": _vm.pageConfig
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.IsLoading),
      expression: "IsLoading"
    }],
    attrs: {
      "element-loading-text": "加载中",
      "data": [_vm.service]
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "下单时间",
      "width": "170"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_vm._v("\n        " + _vm._s(_vm._f("date")(props.row.CreateOn, 'YYYY-MM-DD HH:mm')) + "\n      ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "委托订单",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_vm._v("\n        " + _vm._s(props.row.Code) + "\n      ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "总数量",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_vm._v("\n        " + _vm._s(props.row.TotalQuantity) + "\n      ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "客户总报价",
      "width": "110"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_vm._v("\n        " + _vm._s(props.row.TotalPrice) + "\n      ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "委托类型",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_vm._v("\n        " + _vm._s(_vm._f("EntrustType")(props.row.Type)) + "\n      ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "委托时长",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_vm._v("\n        " + _vm._s(props.row.EntrustDay) + "天\n      ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "区域"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_vm._v("\n        " + _vm._s(props.row.RegionName) + "\n      ")]
      }
    }])
  })], 1), _vm._v(" "), _c('h3', {
    staticStyle: {
      "line-height": "3em"
    }
  }, [_vm._v("物料清单")]), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.IsLoading),
      expression: "IsLoading"
    }],
    attrs: {
      "element-loading-text": "加载中",
      "data": _vm.servicelist
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "expand"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('table', {
          staticClass: "batch_table"
        }, [_c('tbody', _vm._l((props.row.Batchs), function(item) {
          return _c('tr', [_c('td', [_vm._v("\n                批次号：\n                "), _c('p', [_vm._v(_vm._s(item.BatchCode))])]), _vm._v(" "), (item.Type === 2) ? _c('td', [_vm._v("\n                数量：\n                "), _c('p', [_vm._v(_vm._s(item.Quantity))])]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v("\n                原始品项：\n                "), _c('el-tag', {
            attrs: {
              "type": _vm._f("ConditionColor")(item.ItemQualityName)
            }
          }, [_vm._v(_vm._s(item.ItemQualityName))])], 1), _vm._v(" "), _c('td', [_vm._v("\n                入库品项：\n                "), _c('el-tag', {
            attrs: {
              "type": _vm._f("ConditionColor")(item.StockItemQualityName)
            }
          }, [_vm._v(_vm._s(item.StockItemQualityName))])], 1), _vm._v(" "), _c('td', [_vm._v("\n                质检报告：\n                "), _c('p', [_vm._v(_vm._s(item.QualityRemark))])]), _vm._v(" "), _c('td', [_vm._v("\n                分成比例：\n                "), _c('p', [_vm._v(_vm._s(_vm._f("Scale")(item.Scale)))])]), _vm._v(" "), (_vm.pageConfig.Step === 3) ? _c('td', [_vm._v("\n                检测报价：\n                "), _c('p', [_vm._v(_vm._s(item.ConfirmPrice))])]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v("\n                处理结果：\n                "), (item.StockQuantity > 0) ? _c('p', [_vm._v("入库数：" + _vm._s(item.StockQuantity))]) : _vm._e(), _vm._v(" "), (item.ReturnQuantity > 0) ? _c('p', [_vm._v("退回数：" + _vm._s(item.ReturnQuantity))]) : _vm._e(), _vm._v(" "), (item.RepairQuantity > 0) ? _c('p', [_vm._v("维修数：" + _vm._s(item.RepairQuantity))]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v("\n                维修记录：\n                "), (item.RepairQuantity > 0) ? _c('p', [_vm._v("有")]) : _c('p', [_vm._v("无")])])])
        }))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "物料名称／编码",
      "width": "260"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('el-col', [_vm._v(_vm._s(props.row.ItemName))]), _vm._v(" "), _c('el-col', [_vm._v("物料编码：" + _vm._s(props.row.ItemCode))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "客户物料名称／编码",
      "width": "260"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('el-col', [_vm._v(_vm._s(props.row.CustomerItemName))]), _vm._v(" "), _c('el-col', [_vm._v("物料编码：" + _vm._s(props.row.CustomerItemCode))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "品牌"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_vm._v("\n        " + _vm._s(props.row.BrandName) + "\n      ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "机型",
      "width": "140"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_vm._v("\n        " + _vm._s(props.row.MachineName) + "\n      ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "模块",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_vm._v("\n        " + _vm._s(props.row.ModuleName) + "\n      ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "数量"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_vm._v("\n        " + _vm._s(props.row.Quantity) + "\n      ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "报价"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_vm._v("\n        " + _vm._s(props.row.Price) + "\n      ")]
      }
    }])
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ee7b8a8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Entrust/EntrustDetailPage.vue
// module id = 698
// module chunks = 0